export const socialLinks = [
	{
		id: 1,
		name: 'Website',
		icon: 'globe',
		url: 'https://bzeromo.netlify.app/',
	},
	{
		id: 2,
		name: 'GitHub',
		icon: 'github',
		url: 'https://github.com/Bzeromo',
	},
	{
		id: 3,
		name: 'Velog',
		icon: 'pen-tool',
		url: 'https://velog.io/@bzeromo/posts',
	},
	{
		id: 4,
		name: 'Instagram',
		icon: 'instagram',
		url: 'https://www.instagram.com/b_zero_mo/',
	},

];
